import styled from 'styled-components';

export interface StyledAnimatedLogoProps {
  size: number;
}

export const StyledAnimatedLogo = styled.div<StyledAnimatedLogoProps>`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`;
